import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, adminOnly = false, superAdminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();

  // checking session
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--noam-bg)] text-zinc-400 text-sm" data-testid="auth-checking">
        <span className="typing-dot" /><span className="typing-dot" /><span className="typing-dot" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  // Ultra admin route — only the platform owner can enter, regardless of org-role.
  if (superAdminOnly && !user.is_super_admin && !user.is_ultra_admin) {
    return <Navigate to="/app/executive" replace />;
  }
  // Org-scoped admin gate — preserves super_admin / ultra access too.
  if (adminOnly && user.role !== "admin" && user.role !== "super_admin" && !user.is_super_admin) {
    return <Navigate to="/app/executive" replace />;
  }
  return children;
}
